import React, { useState, useEffect } from 'react'
import { Heading, Stack, Button, FormControl, Input, Textarea, ControlledPopover, UserChooser } from '@/components/lib'
import api from '@/api'
import utils from '@/utils/utils'

export default function QueryRaiser ({ trigger, trialId, participantId, responseId, dataTypeId, allowedAssignees, onRaised, portalRef, defaultTitle, defaultDescription }) {
  const [isOpen, setIsOpen] = useState(false)
  const [title, setTitle] = useState(defaultTitle || '')
  const [description, setDescription] = useState(defaultDescription || '')
  const [assignees, setAssignees] = useState([])

  useEffect(() => {
    setTitle(defaultTitle || '')
    setDescription(defaultDescription || '')
  }, [defaultTitle, defaultDescription])

  function save () {
    const data = { title, description, assignees, participant: participantId, response: responseId, dataType: dataTypeId }
    api.queries.create(trialId, data, newQuery => {
      setIsOpen(false)
      setTitle('')
      setDescription('')
      setAssignees([])
      utils.toast('success', 'Query raised')
      onRaised(newQuery)
    }, err => {
      utils.toast('error', 'Unable to raise query', err.message)
    })
  }

  return (
    <>
      <ControlledPopover
        contentProps={{ bg: 'bg.subtle' }}
        portalRef={portalRef}
        isOpen={isOpen}
        onClose={() => setIsOpen(false)}
        trigger={React.cloneElement(trigger, { onClick: () => setIsOpen(true) })}
        header={<Heading size='sm'>Raise a query</Heading>}
        body={
          <Stack spacing={3}>
            <FormControl label='Query title'>
              <Input bg='bg.surface' placeholder='Write a short overview...' value={title} onChange={e => setTitle(e.target.value)} />
            </FormControl>
            <FormControl label='Query description'>
              <Textarea bg='bg.surface' placeholder='Write more details about your query...' value={description} onChange={e => setDescription(e.target.value)} />
            </FormControl>
            <FormControl label='Assign query to'>
              <UserChooser bg='bg.surface' multiple users={allowedAssignees} selectedUsers={assignees || []} onChosen={u => setAssignees(u)} placeholder='Do not assign anyone' />
            </FormControl>
            <Stack direction='row' justify='flex-end' mt={5}>
              <Button onClick={() => setIsOpen(false)} colorPalette='grey' size='sm'>Cancel</Button>
              <Button colorPalette='primary' onClick={save} size='sm' variant='solid'>Raise query</Button>
            </Stack>
          </Stack>
        }
      />
    </>

  )
}
